// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ProductListStroked: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 20 18" enableBackground="new 0 0 20 18" xmlSpace="preserve" fill="currentColor">
<path d="M10,17.83l-0.5-0.29C9.11,17.32,0,11.95,0,5.65C0,2.87,2,0,5.35,0C7.28,0,8.98,0.87,10,2.19C11.02,0.87,12.72,0,14.65,0
	c3,0,5.35,2.48,5.35,5.65c0,6.31-9.11,11.67-9.5,11.9L10,17.83z M5.35,2C3.25,2,2,3.85,2,5.65c0,4.01,5.36,8.21,7.99,9.86
	C11.81,14.34,18,10.07,18,5.65C18,3.85,16.75,2,14.65,2C12.89,2,11,3.17,11,5.06H9C9,3.17,7.11,2,5.35,2z"/>
</svg>;
};

export default React.memo(ProductListStroked);
